/**
 * Graf-farver i brand-udtrykket ([D-471], 12-conventions §98).
 *
 * Designmanualens farver er dusede pasteller (Salvie har chroma 0,03), og de
 * flyder sammen i en graf: som rå chart-palet fejler de både lyshed, chroma og
 * farveblind-adskillelse. Paletten her er derfor DYBERE TRIN af de samme
 * nuancer (samme OKLCH-hue, chroma lige over 0,10), så hver serie stadig
 * aflæses som Salvie, Lys orange, Duset lyserød osv.
 *
 * Valideret 29-10-2026 med dataviz-validatoren (OKLab ΔE x100, Machado 2009):
 *   lys  mod #FFFFFF: farveblind 11,0 / normalsyn 16,7 (nabopar), PASS
 *   mørk mod #1E2121: farveblind  9,1 / normalsyn 16,7 (nabopar), PASS
 * Lys orange og Lys gul ligger under 3:1 mod hvid i lyst tema; de bruges med
 * legende og etiketter (kontrast-lempelsen), aldrig som eneste kendetegn.
 * Rækkefølgen er fast og ens i begge temaer (en serie skifter ikke farve med
 * temaet), og en 9. serie foldes ind i "Øvrige", den genereres aldrig.
 */

/** Kategorisk: Salvie, Lys orange, Duset lyserød, Lys gul, Mørk rød, Lime grøn, Duset blå, Terracotta. */
export const BRAND_CAT_LIGHT = ['#038D86', '#DA9340', '#A75463', '#C8A747', '#942222', '#4F8444', '#136B94', '#C8714F'];
export const BRAND_CAT_DARK = ['#109A93', '#C9832D', '#A74660', '#A79139', '#AC312A', '#5B904F', '#1B84B4', '#B85E31'];

/**
 * Den 6-trins `ramp`, som graferne i dag slår op i med faste indeks (ramp[0]
 * hovedserien, ramp[3] og ramp[4] sammenligningen, ramp[5] den dæmpede
 * baggrundsserie). Ordnet så de par, siderne faktisk tegner sammen, er dem der
 * skiller sig mest: Salvie, Lys orange, Duset lyserød, Terracotta, Lys gul og
 * en neutral Salvie-grå til baggrundsserien.
 */
export const BRAND_RAMP_LIGHT = ['#038D86', '#DA9340', '#A75463', '#C8714F', '#C8A747', '#B9C4C2'];
export const BRAND_RAMP_DARK = ['#109A93', '#C9832D', '#A74660', '#B85E31', '#A79139', '#4A5452'];

/** Op/ned i graferne (vækst/fald, over/under budget), som hex fordi trend-
 *  båndet blander alfa på hex. Lyst tema = delta-tokens --green/--red i
 *  brand-ui.css; mørkt tema lysere, da graferne kun står på mørke flader. */
export const BRAND_POS_LIGHT = '#2F7A55';
export const BRAND_NEG_LIGHT = '#B23A30';
export const BRAND_POS_DARK = '#78C498';
export const BRAND_NEG_DARK = '#EC8074';

/** Rangorden (fx SERP-positioner 1, 2-3, 4-10 ...): én Salvie-nuance, mørk til lys
 *  i lyst tema og lys til mørk i mørkt (validator: monoton, ΔL >= 0,06, PASS). */
export const BRAND_SEQ_LIGHT = ['#004E4A', '#006A64', '#1D857F', '#4E9F99', '#7AB8B3'];
export const BRAND_SEQ_DARK = ['#A8DDD8', '#7AC4BE', '#4BAAA4', '#2E918B', '#157873'];
